define('TescoMobile_Checkout/js/model/agreement-validator',['jquery', 'mage/validation'], function ($) {
  'use strict';

  var checkoutConfig = window.checkoutConfig,
    agreementsConfig = checkoutConfig ? checkoutConfig.checkoutAgreements : {},
    agreementsInputPath = '.checkout-about div.checkout-agreements input';
  return {
    validate: function (hideError) {
      var isValid = true;
      if (!agreementsConfig.isEnabled || $(agreementsInputPath).length === 0) {
        return true;
      }
      $(agreementsInputPath).each(function (index, element) {
        if (!$.validator.validateSingleElement(element, {
          errorElement: 'div',
          hideError: hideError || false
        })) {
          isValid = false;
        }
      });
      return isValid;
    }
  };
});

